// Reports uncaught errors in the app to the backend, which forwards them to
// Sentry when error monitoring is configured there (SENTRY_DSN). Nothing
// personal is sent: the error message, stack, page path and app version only.
import { APP_VERSION } from './version';

const API_URL = process.env.NODE_ENV === 'production' ? '/api' : `http://${window.location.hostname}:4000/api`;
const MAX_PER_PAGE = 10;
let sent = 0;
const seen = new Set();

function report(message, stack) {
  if (process.env.NODE_ENV !== 'production' || sent >= MAX_PER_PAGE) return;
  const key = `${message}|${(stack || '').slice(0, 200)}`;
  if (seen.has(key)) return;
  seen.add(key);
  sent++;
  const body = JSON.stringify({
    message: String(message).slice(0, 500),
    stack: stack ? String(stack).slice(0, 4000) : undefined,
    url: window.location.pathname,
    release: APP_VERSION,
    userAgent: navigator.userAgent,
  });
  try {
    fetch(`${API_URL}/monitoring/client-error`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true,
    }).catch(() => {});
  } catch { /* never let reporting throw */ }
}

export function installErrorReporting() {
  window.addEventListener('error', (e) => {
    if (e.error || e.message) report(e.message || String(e.error), e.error?.stack);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    // Failed API calls are handled (and logged server-side) already.
    if (r && r.isAxiosError) return;
    report(r?.message || String(r), r?.stack);
  });
}

export { report as reportError };
